import React, { useEffect, useState } from "react";
import { Instagram, ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

function timeAgo(iso) {
  const diff = Date.now() - new Date(iso).getTime();
  const days = Math.floor(diff / 86400000);
  if (days === 0) return "today";
  if (days === 1) return "1d ago";
  if (days < 7) return `${days}d ago`;
  return `${Math.floor(days / 7)}w ago`;
}

export default function SocialFeed() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/social-posts")
      .then((r) => setPosts(r.data))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading || posts.length === 0) return null;

  return (
    <section
      className="py-16 lg:py-20 border-t border-[var(--border)]"
      data-testid="social-feed-section"
    >
      <div className="container-nk">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-9">
          <div>
            <p className="eyebrow flex items-center gap-2">
              <Instagram size={13} className="text-gold" />
              // This Week at Naami
            </p>
            <h2 className="font-display text-[44px] md:text-[60px] leading-[0.95] mt-3">
              Fresh from the Counter
            </h2>
          </div>
          <a
            href="#"
            className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-gold hover:gap-3 transition-all"
            data-testid="social-follow-link"
          >
            Follow @naamikitchens
            <ArrowUpRight size={14} />
          </a>
        </div>

        <div className="grid gap-3 grid-cols-2 md:grid-cols-4 lg:grid-cols-4">
          {posts.slice(0, 8).map((p, i) => (
            <a
              key={p.id}
              href={p.permalink}
              target="_blank"
              rel="noopener noreferrer"
              className="social-tile group"
              data-testid={`social-tile-${i}`}
              aria-label={`${p.brand_name} — ${p.caption}`}
            >
              <div className="social-tile-img">
                <img src={p.image} alt={p.caption} loading="lazy" />
              </div>
              <div className="social-tile-overlay">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-mono text-[9.5px] uppercase tracking-[0.14em] text-gold">
                    @{p.brand_name.toLowerCase().replace(/[^a-z0-9]+/g, "")}
                  </span>
                  <span className="font-mono text-[9.5px] uppercase tracking-[0.14em] text-[var(--text)]/60">
                    {timeAgo(p.posted_at)}
                  </span>
                </div>
                <p className="text-[12.5px] leading-snug line-clamp-3 font-light">
                  {p.caption}
                </p>
              </div>
              <Instagram size={16} className="social-tile-icon" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
